import { QueryClient } from '@tanstack/react-query';
import {
  multiExchangeProvider,
  binanceAdapter,
  coinbaseAdapter,
  krakenAdapter,
  bybitAdapter,
  okxAdapter,
  bitvavoAdapter,
} from 'hopcharts';

/**
 * Market data straight from the exchanges' public APIs (all send CORS
 * headers), with WebSocket streams for live candles and tickers.
 */
export const marketProvider = multiExchangeProvider(
  [binanceAdapter(), coinbaseAdapter(), krakenAdapter(), bybitAdapter(), okxAdapter(), bitvavoAdapter()],
  { id: 'ch-markets' },
);

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
});
